angular.module('rental')
    .component('rentalResourceBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '='
        },
        templateUrl: 'app/rental/resource/_btn-options.html',
        controller: function (RentalResourceService, FilesLibrary, FilesSimpleUploadService, Principal, RentalResourceConst) {
            this.RentalResourceService = RentalResourceService;
            this.FilesLibrary = FilesLibrary;
            this.FilesSimpleUploadService = FilesSimpleUploadService;

            this.fileResourceName = "RENTAL-RESOURCE"

            this.$onInit = () => {
                this.canRead = Principal.hasAnyAuthority([RentalResourceConst.RoleResourceRead])
                this.canWrite = Principal.hasAnyAuthority([RentalResourceConst.RoleResourceWrite])
            }

            this.canEdit = () => {
                return this.canWrite
            }

            this.canDelete = () => {
                return this.canWrite
            }
        }
    })
